export default "__VITE_ASSET__BK5e_4dr__"